<template>
  <div class="welcome" :class="{'is-faded': screen.fade, 'is-hidden': screen.hide}">
    <div class="welcome__bg1 img-w">
      <img src="@/assets/img/welcome-bg1-mod.png" alt="">

      <iframe
        @load="showIframe = true"
        :class="{'-show' : showIframe}"
        src="./canvas/canvas_v2_2.html" />
    </div>
    <div class="welcome__bg2 img-w">
      <img src="@/assets/img/welcome-bg2.png" alt="">
    </div>
    <div class="welcome__bg3 img-w">
      <img src="@/assets/img/welcome-bg3.png" alt="">
    </div>
<!--    <div class="mobile-visible welcome__bg4 img-w">-->
<!--      <img src="@/assets/img/pot.png" alt="">-->
<!--    </div>-->

    <div class="welcome__column">
      <div class="welcome__str1">Как</div>
      <div class="welcome__str2">изменилась</div>
      <div class="welcome__str3">Россия</div>
      <p class="welcome__descr">
        {{ 'Эти законы уже улучшили жизнь людей. Как они помогут миллионам Россиян?' | typograf }}
      </p>
    </div>

    <div class="welcome__kv img-w">
<!--      <img src="@/assets/img/kv.png" alt="">-->
      <iframe src="./canvas/canvas_v1_3/canvas_v1_3.html" />

      <iframe class="-mod" src="./canvas/canvas_v3_2.html" />
    </div>

    <div @click="slideNextScreen" class="welcome__arrow">
      <div class="welcome__arrow-icon img-w">
        <img src="@/assets/img/arrow.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import './welcome.styl'
export default {
  name: 'Welcome',
  data () {
    return {
      showIframe: null,
      screen: {
        fade: false,
        hide: false
      }
    }
  },
  methods: {
    slideNextScreen () {
      this.$emit('updateCurrent', 1)
    }
  }
}
</script>
